import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=05e98b6d&scoped=true"
import script from "./radio.vue?vue&type=script&lang=js"
export * from "./radio.vue?vue&type=script&lang=js"
import style0 from "./radio.vue?vue&type=style&index=0&id=05e98b6d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e98b6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e98b6d')) {
      api.createRecord('05e98b6d', component.options)
    } else {
      api.reload('05e98b6d', component.options)
    }
    module.hot.accept("./radio.vue?vue&type=template&id=05e98b6d&scoped=true", function () {
      api.rerender('05e98b6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/radio/radio.vue"
export default component.exports